"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect = exports.protobufPackage = void 0;
exports.protobufPackage = "cerbos.effect.v1";
var Effect;
(function (Effect) {
    Effect[Effect["EFFECT_UNSPECIFIED"] = 0] = "EFFECT_UNSPECIFIED";
    Effect[Effect["EFFECT_ALLOW"] = 1] = "EFFECT_ALLOW";
    Effect[Effect["EFFECT_DENY"] = 2] = "EFFECT_DENY";
    Effect[Effect["EFFECT_NO_MATCH"] = 3] = "EFFECT_NO_MATCH";
})(Effect || (exports.Effect = Effect = {}));
//# sourceMappingURL=effect.js.map